module.exports = __webpack_public_path__ + "img/home.660a817e.webp";